import * as actions from "Actions";
import * as api from "Api";
import { SELECT_TRIMESTRE } from "Config";

export const saveAccountingDates = () => (dispatch, getState) => {
  const { token } = getState().auth;
  const { accountingDates, startDate, organization } = getState().balance;

  return dispatch(
    actions.saveAccountingDates(
      api.saveAccountingDates({
        token,
        accountingDates,
        startDate,
        data: organization
      })
    )
  );
};

export const saveBalance = () => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const {
      sourceModel,
      modelConfig,
      multipleModelConfig,
      balanceAttachment,
      organization,
      trimesterConfig: { firstTrimester, lastTrimester }
    } = getState().balance;

    let trimesters = [];
    SELECT_TRIMESTRE.map((item, i) => {
      if (item.value >= firstTrimester && item.value <= lastTrimester) {
        trimesters.push(item.value);
      }
    });

    let months = [];
    for (let i = 1; i < 13; i++) {
      months.push(i);
    }
    let periodConfig = {
      trimesters: trimesters,
      semesters: [1, 2],
      months: months
    };

    return dispatch(
      actions.saveBalance(
        api.importBalance({
          token,
          sourceModel,
          modelConfig,
          periodConfig,
          multipleModelConfig,
          balanceAttachment,
          data: organization
        })
      )
    );
  };
};

export const saveAnnexes = (annexes, clientUen) => {
  return (dispatch, getState) => {
    return dispatch(actions.saveAnnexes(api.importAnnexes(annexes, clientUen)));
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/balance.js